import { render } from "./CreateDevTicket.vue?vue&type=template&id=4f9937c4&scoped=true"
import script from "./CreateDevTicket.vue?vue&type=script&lang=js"
export * from "./CreateDevTicket.vue?vue&type=script&lang=js"

import "./CreateDevTicket.vue?vue&type=style&index=0&id=4f9937c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9937c4"]])

export default __exports__